import React, { useState } from 'react';

function DomesticViolenceResources() {
  const [showAllResources, setShowAllResources] = useState(false);

  // Emergency hotlines and resources
  const emergencyResources = [
    {
      name: "National Domestic Violence Hotline",
      phone: "1-800-799-7233",
      textLine: "Text START to 88788",
      website: "https://www.thehotline.org/",
      description: "24/7 crisis support, safety planning, and resources"
    },
    {
      name: "Crisis Text Line",
      phone: "",
      textLine: "Text HOME to 741741",
      website: "https://www.crisistextline.org/",
      description: "24/7 text support for crisis situations"
    },
    {
      name: "National Suicide Prevention Lifeline",
      phone: "988",
      textLine: "",
      website: "https://988lifeline.org/",
      description: "Mental health crisis support and suicide prevention"
    }
  ];

  // Support organizations and legal resources
  const supportResources = [
    {
      name: "WomensLaw.org",
      website: "https://www.womenslaw.org/",
      description: "Legal information, state-specific resources, and safety planning"
    },
    {
      name: "National Network to End Domestic Violence",
      website: "https://nnedv.org/",
      description: "Resources, policy advocacy, and support for survivors"
    },
    {
      name: "National Center on Domestic Violence, Trauma & Mental Health",
      website: "http://www.nationalcenterdvtraumamh.org/",
      description: "Support for addressing trauma, substance abuse, and mental health"
    },
    {
      name: "RAINN (Rape, Abuse & Incest National Network)",
      website: "https://www.rainn.org/",
      description: "Resources for sexual assault survivors"
    },
    {
      name: "National Resource Center on Domestic Violence",
      website: "https://www.nrcdv.org/",
      description: "Information and resources for professionals and survivors"
    },
    {
      name: "Love Is Respect",
      website: "https://www.loveisrespect.org/",
      description: "Support for young people experiencing dating abuse"
    }
  ];

  // Safety planning tips
  const safetyTips = [
    "Create a code word to alert trusted friends/family that you need help",
    "Keep important documents (ID, birth certificates, financial records) in a safe, accessible place",
    "Save emergency contacts under innocuous names in your phone",
    "Document incidents with dates, times, and descriptions when safe to do so",
    "Create multiple exit routes from your home and practice them",
    "Identify safe locations you can go to at any time (24/7)",
    "Prepare an emergency bag with essentials (medication, clothes, cash)",
    "Consider using a secure browser and clearing your history when researching resources",
    "Review your digital security (change passwords, check location services on devices)"
  ];

  return (
    <div className="card">
      <div className="card-header">
        <h2>Domestic Violence Resources</h2>
        <p className="safety-note">
          <strong>Quick Exit:</strong> Press the "Escape" key or click the "Quick Exit" button at any time to immediately leave this page.
        </p>
      </div>
      <div className="card-body">
        <div className="emergency-resources">
          <h3>Emergency Support Hotlines</h3>
          <div className="resources-list emergency">
            {emergencyResources.map((resource, index) => (
              <div key={index} className="resource-item emergency">
                <h4>{resource.name}</h4>
                {resource.phone && <p className="phone"><strong>Call:</strong> {resource.phone}</p>}
                {resource.textLine && <p className="text-line"><strong>Text:</strong> {resource.textLine}</p>}
                <p className="description">{resource.description}</p>
                <a href={resource.website} target="_blank" rel="noopener noreferrer" className="resource-link">
                  Visit Website
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="safety-planning">
          <h3>Safety Planning Tips</h3>
          <ul className="safety-tips-list">
            {safetyTips.map((tip, index) => (
              <li key={index} className="safety-tip">{tip}</li>
            ))}
          </ul>
        </div>

        <div className="support-resources">
          <h3>Support Organizations</h3>
          <div className="resources-list support">
            {(showAllResources ? supportResources : supportResources.slice(0, 3)).map((resource, index) => (
              <div key={index} className="resource-item support">
                <h4>{resource.name}</h4>
                <p className="description">{resource.description}</p>
                <a href={resource.website} target="_blank" rel="noopener noreferrer" className="resource-link">
                  Visit Website
                </a>
              </div>
            ))}
          </div>
          
          {supportResources.length > 3 && (
            <button 
              className="btn btn-outline"
              onClick={() => setShowAllResources(!showAllResources)}
            >
              {showAllResources ? 'Show Fewer Resources' : 'Show More Resources'}
            </button>
          )}
        </div>

        <div className="legal-documentation">
          <h3>Legal Documentation</h3>
          <p>
            Documenting incidents of abuse can be crucial for legal proceedings, including restraining orders
            and custody cases. Use the Safety Documentation tool to securely track incidents.
          </p>
          <div className="documentation-tips">
            <h4>Tips for Documentation:</h4>
            <ul>
              <li>Record dates, times, and detailed descriptions of incidents</li>
              <li>Note any witnesses present</li>
              <li>Document any injuries with photos when safe to do so</li>
              <li>Keep records of police reports and medical visits</li>
              <li>Save threatening messages, emails, or voicemails</li>
              <li>Consider keeping a secure journal of ongoing behavior patterns</li>
            </ul>
          </div>
        </div>

        <div className="truth-credo">
          <p>
            Your experience matters. By documenting what has happened and seeking support,
            you are bearing witness to your truth and taking steps toward healing.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DomesticViolenceResources;